import { render, staticRenderFns } from "./optionAssociation.vue?vue&type=template&id=bde67144&scoped=true&"
import script from "./optionAssociation.vue?vue&type=script&lang=js&"
export * from "./optionAssociation.vue?vue&type=script&lang=js&"
import style0 from "./optionAssociation.vue?vue&type=style&index=0&id=bde67144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde67144",
  null
  
)

export default component.exports